import apiClient from '../client'
import type { SunatResponse, ReinfoResponse } from '../models/response'

const BASE_PATH = '/scraping'

export const scrapingService = {
  /**
   * Consulta SUNAT por RUC - obtiene datos del contribuyente
   */
  async consultarSunat(ruc: string): Promise<SunatResponse> {
    return apiClient.get<SunatResponse>(`${BASE_PATH}/sunat/${ruc}`)
  },

  /**
   * Consulta REINFO por RUC - obtiene derechos mineros
   */
  async consultarReinfo(ruc: string): Promise<ReinfoResponse> {
    return apiClient.get<ReinfoResponse>(`${BASE_PATH}/reinfo/${ruc}`)
  },

}

export default scrapingService
